import { MagpieConnection } from 'magpie-lib/connection';
import { navVisibilityControls } from 'navigation-messaging/messages';
import { navigationPublicApiTopicDef } from 'navigation-messaging/topics';
import { waitForPublicApiAvailable } from 'navigation-messaging/utils/waitForPublicApiAvailable';
import { useEffect } from 'react';
const source = 'pricing-pages-unified-ui';
function useNavigationVisibility({
  show = false
}) {
  useEffect(() => {
    const topic = MagpieConnection.get().forTopic(navigationPublicApiTopicDef);
    let cancelled = false;
    const changeNavigationVisibility = async () => {
      try {
        await waitForPublicApiAvailable();
        if (cancelled) {
          return;
        }
        const message = navVisibilityControls.changeNavVisibility.create({
          source,
          shouldShowToolbar: show,
          shouldShowVerticalNav: show
        });
        topic.publish(message, {
          onReply: __reply => {},
          onError(__error) {}
        });
      } catch (__error) {
        // If the public API is not available, we can ignore the error and continue.
        // This means that the navigation will not be hidden, but it will not break the application.
      }
    };
    void changeNavigationVisibility();
    return () => {
      cancelled = true;
      const showMessage = navVisibilityControls.changeNavVisibility.create({
        source,
        shouldShowToolbar: !show,
        shouldShowVerticalNav: !show
      });
      topic.publish(showMessage, {
        onReply: __reply => {},
        onError(__error) {}
      });
    };
  }, [show]);
}
export default useNavigationVisibility;